export enum Amount {
  BASE = 'Base',
  TARGET = 'Target'
}